export default {
      id: "domaine-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#domaine-usage",
      toString: function () {
        return this.url;
      }
    }